import React from "react";
import AppRoutes from "./Routes/Route";

function App() {
  return (
    <div>
      <AppRoutes />
    </div>
  );
}

export default App;
